import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class CourseProgressRexMyLessonsRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductRex = 'rex'
    const precinct: LegacyPrecinctMyLessons = 'my_lessons'
    const stats = await this.makeStatsRequests(product, precinct, statsScope, period)

    return {
      product,
      precinct,
      uiScope,
      scopedStudents: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests = async (
    product: LegacyProductRex,
    precinct: LegacyPrecinctMyLessons,
    scope: StudentsScope,
    period: NormalizedInterval,
  ) => {
    const { studentEvents } = this
    return RSVP.hash({
      myLessonsProgressTotals: studentEvents.courseProgressTotals(product, precinct, scope, period),
      myLessonsProgressAverages: studentEvents.courseProgressAverages(product, precinct, scope, period),
      myLessonsProgressCategories: studentEvents.courseProgressCategories(product, precinct, scope, period),
      myLessonsProgressHistory: studentEvents.courseProgressLessonHistory(product, precinct, scope, period),
    })
  }
}

export default CourseProgressRexMyLessonsRoute
